import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { validateErrorTicket, validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import {
    createNewTicketAPI,
} from '@/service/ticketService';
import { I18n } from 'aws-amplify';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { createKibanaLogAPI } from '@/service/logKibanaService';

export const createMasterKnowledgeTicketHandler = async (
    tabId,
    panelType,
    formData,
    userDetail,
    corporationDetail,
    panelId,
    argsAll,
    fieldListData,
    aiAutoSelectedData
) => {
    // check selectedForm
    if (Utils.isEmptyString(argsAll.selectedForm)) {
        argsAll.setIsErrorSelected(true);
        return;
    }

    argsAll.setIsLoading(true);

    let status = '';
    const statusField = fieldListData.find((fieldData) => fieldData.type === 'WORKFLOW');
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.fieldId;
    }

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData, aiAutoSelectedData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }


    // validate
    if (validateErrorTicket(argsAll, fields)) {
        argsAll.setIsLoading(false);
        return;
    }

    let publicType = Constant.KNOWLEDGE_PUBLIC_TYPE.INTERNAL;
    let publicRange = userDetail.id;

    switch (formData.publicRange) {
        case Constant.KNOWLEDGE_PUBLIC_RANGE.PROJECT_ONLY:
            publicRange = localStorageUtil.getSelectedProjectId();
            break;
        case Constant.KNOWLEDGE_PUBLIC_RANGE.CORPORATION_ONLY:
            publicRange = corporationDetail.id;
            break;
        case Constant.KNOWLEDGE_PUBLIC_RANGE.ALL:
            publicType = Constant.KNOWLEDGE_PUBLIC_TYPE.EXTERNAL;
            publicRange = Constant.KNOWLEDGE_PUBLIC_RANGE.ALL;
            break;
        default:
            break;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading
    );

    let requestBody = {
        createTicketRequestDto: {
            outline: formData.outline,
            corporationOrigin: corporationDetail.id,
            description: formData.description,
            createUserId: userDetail.id,
            projectOrigin: localStorageUtil.getSelectedProjectId(),
            projectTarget: localStorageUtil.getSelectedProjectId(),
            corporationTarget: corporationDetail.id,
            ticketType: Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: localStorageUtil.getSelectedProjectId(),
            status: status,
            fields: fields,
            type: argsAll.selectedForm,
            customer: Constant.NA,
            publicType,
            publicRange,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            sessionId: localStorageUtil.getSessionBrowserId()
        },
    };

    // call API create ticket
    let newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }

    let viewPermissions = argsAll.viewPermissions || [];
    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: argsAll.corporationDetail,
        rootProjectDetail: argsAll.projectInuseDetail,
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            additionalViewPermissions: argsAll.additionalViewPermissions,
            viewPermissions: viewPermissionsSave,
            ticketType: Constant.TICKET_TYPE.MASTER_KNOWLEDGE
        },
        isCreateKnowledge: true,
        isCreateCSV: false,
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: formData.outline,
        API: argsAll.API,
    });

    argsAll.enqueueSnackbar(I18n.get('COMMSG041'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};
